<template>
    <div>
        <layout-headers title="suppliersPageTitle" text="suppliersPageSubtitle" :redirectButtons="redirectButtons" />
        <filters :tableData="tableData" v-model="search" @filtered-list="getFilteredList" :fields="['legal_name', 'city', 'email', 'web']" />
        <br>
        <el-card v-loading="loading">
            <el-table :data="filteredData" empty-text="No results">
                <el-table-column 
                    width="80"
                    prop="logo"
                    :label="$t('providerAvatar')">
                    <template slot-scope="scope">
                       <img @error="scope.row.logo = ''" :src="scope.row.logo ? url + scope.row.logo+ '?q='+ timestamp : defaultImage">
                    </template>
                </el-table-column>

                <el-table-column sortable prop="legal_name" :label="$t('providerLegalName')"/>
                <el-table-column sortable prop="display_name.en" :label="$t('providerDisplayName')"/>
                <el-table-column sortable prop="city" :label="$t('providerCity')"/>
                <el-table-column sortable prop="provider_type.type_name" :label="$t('providerProviderType')"/>

                <el-table-column prop="actions" fixed="right" width="150" :label="$t('tableActions')">
                    <template slot-scope="scope">
                        <el-tooltip 
                            class="item" 
                            effect="dark"
                            placement="left-start">
                            <div slot="content">
                                {{ $t('tooltipInfo') }}
                            </div>
                            <el-button type="info" 
                                icon="el-icon-view"
                                class="table-button"
                                @click="$router.push({name: 'SingleProvider', params: {id: scope.row.id}})">
                            </el-button>
                        </el-tooltip>
                        <el-button icon="el-icon-edit" class="table-button" @click="edit('ProviderEdit', scope.row, 'provider')"/>
                        <el-button icon="el-icon-delete" class="table-button" @click="showModal(scope.row.id, scope.$index)"/>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
        

        <modal :config="modalConfig" @closeModal="deleteSupplier" />
    </div>
</template>

<script>
    import {ImageUrl} from '@/main'
    import {mapGetters} from 'vuex'
    import api from '@/api/api';
    import LayoutHeaders from '../LayoutPart/LayoutHeaders';
    import Filters from '../Filters/Filter';
    import { success } from '../Notification/notification';
    import {getFilteredList} from '@/helpers/helpers';
    import Modal from '../Modal/Modal'
    import {showModal, closeModal} from "../Modal/ModalHelpers";
    import {edit} from '../../helpers/helpers.js'
    import noImage from '@/assets/no_image.png'

    export default {
        components: {
            LayoutHeaders,
            Filters,
            Modal,
        },
        computed: {
            ...mapGetters({
                suppliers: 'getSuppliers'
            }),
            timestamp() {
                return Date.now();
            }
        },
        data() {
            return {
                modalConfig: { show: false },
                filteredData: [],
                search: '',
                tableData: [],
                loading: true,
                url: ImageUrl,
                defaultImage: noImage,
                redirectButtons: [
                    {
                        path: 'ProviderAdd',
                        param: {
                            isEdit: false,
                            provider: {
                                id: null,
                                user_id: null,
                                provider_type_id: 2,
                                legal_name: '',
                                display_name: {},
                                logo: '',
                                city: '',
                                zip: '',
                                address: '',
                                phone: '',
                                fax: '',
                                email: '',
                                description: {},
                                web: '',
                                imageData: ''
                            }
                        },
                        text: 'suppliersButton'
                    }
                ]
            }
        },
        watch: {
            suppliers () {
                this.tableData = this.suppliers;
                this.filteredData = this.suppliers;
                this.loading = false
                // console.log('sup',this.suppliers);
            }
        },
        async created () {
            await setTimeout(() => { 
                this.$store.dispatch('fetchSuppliers')
            }, 1000)
        },
        methods: {
            edit,
            getFilteredList,
            success,
            showModal,
            deleteSupplier () {
                const { id } = this;
                this.modalConfig.show = false;
                api.deleteProvider(id)
                .then(() => {
                    this.$delete(this.suppliers, this.index);
                    this.success('Supplier', 'deleted');
                })
                .catch(err => {
                })
            },
            
        }
    }
</script>

<style scoped>
    .table-button {
        width: 30px !important; 
        height: 30px !important; 
        padding: 0 !important; 
        margin: 0 !important;
        background: transparent !important;
        color: darkgrey;
        font-size: 20px;
        font-weight: 800;
        border: none;
    }

    .table-button:hover {
        color: #409EFF !important;
    }
    .cell img {
        width: 55px;
        height: 55px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Providers/SuppliersTable.vue